export enum BrokerDataDeclarationSectionEnum {
    BAD_SECTION_1 = 1,
    BAD_SECTION_2 = 2,
    BAD_SECTION_3 = 3,
    BAD_SECTION_4 = 4,
    BAD_SECTION_5 = 5,
    BAD_SECTION_6 = 6,
    BAD_SECTION_7 = 7,
    BAD_SECTION_8 = 8,
    BAD_SECTION_9 = 9,
    
}


// WEBPACK FOOTER //
// ./src/app/model/enumModel.ts